import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query StatusHistoryGridQuery(
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: lockPeriods(
            options: {
              startRow: $startRow
              endRow: $endRow
              sorting: $sortModel
              filters: $filters
            }
          ) {
            id
            tableId
            serviceCategory {
              id
              tableId
              name
            }
            status
            begin
            end
            reason
            initiator
          }
        }
      }
    }
  }
`
